import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import $ from 'jquery';
import Moment, { now } from 'moment';
import { Modal, Button } from 'react-bootstrap';
import parentStateHandler from '../../commonJS/parentStateHandler';
import UniqueIdGenerator from '../../commonJS/UniqueIdGenerator';
import languageVerifier from '../../commonJS/languageVerifier';
import custJqAjax from '../../commonJS/custJqAjax';
import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'

import '../css/bootstrap.min.css';
import '../css/bootstrap-theme.min.css';
import '../css/fixed-data-table.min.css';
import '../css/main.css';
import '../css/react-datepicker.min.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
// import '../css/react-select.min.css';


const AlertModal = props => (
	<Modal show={props.showModal} onHide={props.onClick} style={{ zIndex: '2000' }}>
		<Modal.Header>
			<Modal.Title>System Message</Modal.Title>
		</Modal.Header>

		<Modal.Body>
			Your session has expired, please relogin.
    	</Modal.Body>

		<Modal.Footer>
			<Button onClick={props.onClick}>Close</Button>
		</Modal.Footer>
	</Modal>
);

class SkyFamily extends Component {
	componentWillMount() {
		this.consts = {
			// old
			// 語言包儲存在localStorage避免重複抓取
			// 為確保語言包更新時能更新localStorage內容
			// 設定版本號做比對，當語言包更新時，變更版本號以更新
			// a、b切換即可
			// languageDataVersion: 'a'
			// new
			// 版本號改使用當下登入的日期及時間
			languageDataVersion: Moment(new now()).format('MMDDYYYY')
		};

		this.ajaxsWip = [];

		let lang;
		// 語系判斷
		const
			localSetLang = localStorage.languageCode,
			clientSetLang = navigator.language || navigator.browserLanguage;

		// 有設定抓設定，否則抓瀏覽器設定，若瀏覽器設定不可用則傳回通用的en
		lang = localSetLang || languageVerifier(clientSetLang) || 'en';

		this.handlers = {
			getLanguageData: () => {
				const languageData = sessionStorage.languageData,
					languageDataVersion = localStorage.languageDataVersion;

				if (languageDataVersion === this.consts.languageDataVersion && languageData) {
					if (languageData !== 'Data loading...') {
						const parsedLanguageData = JSON.parse(languageData);
						this.setState({
							languageData: parsedLanguageData
						});
						// 暫時方式，後續改redux
						window.myConsts = {
							languageData: parsedLanguageData,
							languageCode: this.state.languageCode
						};

					}
					return;
				} else sessionStorage.languageData = 'Data loading...';

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.jqAjaxIdGenerator.getId(),
					url: '/api/GetAllTranslation.php',
					processData: false,
					contentType: false,
					success: res => {
						if (res.status !== '0') return;
						// 改成好用的資料結構
						let data = res.result, transformedData = {};

						for (let i = data.length - 1; i >= 0; i--) {
							transformedData[data[i].id] = data[i];
						}

						window.myConsts = {
							languageData: transformedData,
							languageCode: this.state.languageCode
						};

						this.setState({ languageData: transformedData });

						sessionStorage.languageData = JSON.stringify(transformedData);
						localStorage.languageCode = this.state.languageCode;
						localStorage.languageDataVersion = this.consts.languageDataVersion;
					}
				});
			},
			routeHandler: (route, method) => {
				if (!route) browserHistory.push('/');
				else if (!method) browserHistory.push(route);
				else browserHistory[method](route);
			},
			stateHandler: (states, newValues) => {
				parentStateHandler({ states, newValues, parentThis: this });
			},
			logoutHandler: () => {
				sessionStorage.removeItem('isLogin');
				sessionStorage.removeItem('userName');
				sessionStorage.removeItem('userId');
				sessionStorage.removeItem('groupId');
				sessionStorage.removeItem('userPermission');
				sessionStorage.removeItem('systemEnvironment');
				sessionStorage.removeItem('isAdmin');
				sessionStorage.removeItem('isSuperAdmin');
				sessionStorage.removeItem('userPhotoSrc');
				sessionStorage.removeItem('languageData');

				$.ajax({
					type: 'POST',
					url: '/api/W_Logout.php',
					success: res => {
						if (res.status === '0') {
							this.handlers.routeHandler('/login', 'replace');
						}
					},
					error: (xhr, status, error) => { }
				});

			},
			closeModalOnClick: () => {
				this.setState({ showModal: false });
				this.handlers.logoutHandler();
			}
		};

		this.jqAjaxIdGenerator = new UniqueIdGenerator(1);

		// 以下機制目標對象是jquery的ajax物件，非jquery的不會被監控，
		// 例如axios發出的ajax

		// 建立全域ajax requests註冊機制[]
		this.xhrQueue = {};
		$(document).ajaxSend((e, jqXhr, settings) => {
			// 要列入管控的就會給id
			if (jqXhr.custId) {
				this.xhrQueue[jqXhr.custId] = jqXhr;
				// 超過100個key就重置，提供100個api的周轉空間，而非無限
				if (this.jqAjaxIdGenerator.getCurrentNumber() > 100) this.jqAjaxIdGenerator.reset();
			}
		});

		// 建立全域ajax request畢業機制
		$(document).ajaxComplete((e, jqXhr, settings) => {
			// 有註冊入學的的才會畢業
			if (jqXhr.custId) {
				this.xhrQueue[jqXhr.custId] = null;
			}

			// 405表示session expired，在這裡對全部ajax做檢查
			if (jqXhr.responseJSON) {
				if (jqXhr.responseJSON.status === '405') {
					if (!this.state.showModal) this.setState({ showModal: true });
				}
			}

		});

		// 建立ajax取消機制，以避免call setState in unmount components.
		this.ajaxAborter = ajaxIdListToAbort => {
			let len = ajaxIdListToAbort.length;

			for (let i = 0; i < len; i++) {
				this.xhrQueue[ajaxIdListToAbort[i]].abort();
			}
			// abort()也會觸發ajaxcomplete事件讓其畢業

			// 因網路速度太慢導致累積太多ajax請求未完成時，
			// 可能Aborter還來不及全部取消就會有的已經完成，
			// 還是可能發生setState in unmount...
		};

		// 安全性要強化
		this.state = {
			isLogin: sessionStorage.isLogin,
			userName: sessionStorage.userName,
			language: localStorage.language,
			languageData: { dataNotReady: true },
			languageCode: lang,
			userId: sessionStorage.userId,
			groupId: sessionStorage.groupId,
			userPhotoSrc: sessionStorage.userPhotoSrc,
			isAdmin: sessionStorage.isAdmin,
			isSuperAdmin: sessionStorage.isSuperAdmin,
			userPermission: sessionStorage.userPermission ? JSON.parse(sessionStorage.userPermission) : '',
			systemEnvironment: sessionStorage.systemEnvironment ? JSON.parse(sessionStorage.systemEnvironment) : '',
			showModal: false,
		};

		// 暫時性的處理root route對應的內容，待架構定案後調整
		if (browserHistory.getCurrentLocation().pathname === '/') {
			this.handlers.routeHandler('/salesky', 'replace');
		}

		// 取得多國語言資料
		this.handlers.getLanguageData();
	}

	render() {
		if (this.state.languageData.dataNotReady) return null;

		let propsPackageFromSkyFamily = {
			jqAjaxIdGenerator: this.jqAjaxIdGenerator,
			ajaxAborter: this.ajaxAborter,
			isAdmin: this.state.isAdmin,
			groupId: this.state.groupId,
			isSuperAdmin: this.state.isSuperAdmin,
			userPermission: this.state.userPermission,
			systemEnvironment: this.state.systemEnvironment
		};

		//傳遞props給router傳過來的this.props.children
		let child = this.props.children ? React.cloneElement(this.props.children, {
			routeHandler: this.handlers.routeHandler,
			stateHandler: this.handlers.stateHandler,
			isLogin: this.state.isLogin,
			userName: this.state.userName,
			language: localStorage.language,
			userId: this.state.userId,
			languageData: this.state.languageData,
			languageCode: this.state.languageCode,
			userPhotoSrc: this.state.userPhotoSrc,
			userPermission: this.state.userPermission,
			systemEnvironment: this.state.systemEnvironment,
			logoutHandler: this.handlers.logoutHandler,
			propsPackageFromSkyFamily
		}) : '';

		return (
			<div>
				<AlertModal
					showModal={this.state.showModal}
					onClick={this.handlers.closeModalOnClick} />
				{child}
			</div>
		);
	}
}

export default SkyFamily;



// WEBPACK FOOTER //
// ./src/skyfamily/routes/SkyFamily.jsx